import { LOAD_PREMIUM_SUCCESS } from './action-types';

import { SIGN_OUT_SUCCESS } from '../auth';

export const PremiumState = false;

export function premiumReducer(state = PremiumState, { payload, type }) {
  switch (type) {
    case LOAD_PREMIUM_SUCCESS:
      return payload;

    case SIGN_OUT_SUCCESS:
      return PremiumState;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/core/premium/reducer.js
 **/